
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Définition : une landing page, c’est quoi ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Pour assurer votre visibilité sur Internet, vous avez le choix entre plusieurs pages Web professionnelles.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Définition : une landing page, c’est quoi ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Pour assurer votre visibilité sur Internet, vous avez le choix entre plusieurs pages Web professionnelles.",
        },
      ],
    };
  },
};
